import React from "react"
import styled from "styled-components"
import media from "../../utils/media"
import { Link } from "gatsby"
import theme from "../../utils/theme"
import { useContext } from "react"
import { FooterContext } from "./Footer"
import { toRem } from "../../utils"

export const withSecondary = Component => props => {
  const state = useContext(FooterContext)
  const newProps = { ...props, secondary: state.secondary }

  return <Component {...newProps} />
}

export const Container = styled.div`
  margin-top: 0;
  overflow: hidden;
  width: 100%;
  background: rgb(255, 216, 0);
  background: ${props =>
    props.gradient
      ? "linear-gradient(135deg,rgba(255, 216, 0, 1) 0%, rgba(255, 119, 0, 1) 100%)"
      : "white"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0;
`

export const List = styled.ul`
  width: 100%;
  align-items: center;
  margin-bottom: 0;
`

export const ListItemElement = withSecondary(styled.li`
  list-style: none;
  margin-top: ${props => (props.compact ?  "1em" : "2em")};
  margin: ${props => (props.margin ?  props.margin : null)};
  color: ${props => (props.secondary ? "#fff" : null)};
`)

export const SocialListItem = styled.li`
  list-style: none;
  display: flex;
  justify-content: space-between;
`

export const SocialIcon = withSecondary(styled.img`
  margin-right: 0.5em;
  color: ${props => (props.secondary ? "#fff" : null)};
`)

export const FooterLogo = styled.img`
  width: 160px;
  margin-top: 7rem;
`

export const SubItem = withSecondary(styled.li`
  list-style: none;
  margin-right: 4rem;
  ${media.tablet`margin-top: calc(1.45rem / 2)`};
  color: ${props => (props.secondary ? "#fff" : null)};
`)

export const MobileFlex = styled.div`
  display: flex;
  margin: auto;
`

export const MobileHeaderFlex = withSecondary(styled.div`
  display: flex;
  margin: auto;
  border-bottom: 1px solid;
  border-color: ${props => (props.secondary ? "#fff" : "#ccc")};
  margin-right: 2.5em;
`)

export const MobileHeaderIcon = withSecondary(styled.p`
  text-align: right;
  margin-bottom: 0;
  margin-top: 1rem;
  margin: ${props => (props.margin ?  props.margin : null)};
  color: ${props => (props.secondary ? "#fff " : "#575757")};
`)

export const MobileStoresWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: space-around;
  align-items: flex-start;
  margin-right: 1rem;
`

export const MobileSocialListItem = styled.li`
  color: black;
  list-style: none;
  text-align: end;
  margin-right: 2rem;
  padding-top: .7rem;
  padding-bottom: 1.5rem;
  ${media.tablet`margin-right: 8rem`};
  ${media.phone`
    margin-right: 2rem;
    a {
      margin-right: 0.5rem;
    }
  `};
`

export const ItemHeaderFlex = styled.div`
  display: flex;
  margin: auto;
  align-items: left;
`

export const FooterLink = styled(Link)`
  text-decoration: none;
  color: ${theme.colors.text};

  & :visited {
    color: ${theme.colors.text};
  }
`
export const Brand = styled.p`
  font-weight: 600;
  font-size: ${toRem(15)};
  text-align: right;
  padding-right: 1rem;
  color: ${props => (props.secondary ? "#fff " : "#575757")};
`
